document.addEventListener('DOMContentLoaded', function () {
  const fileFields = document.querySelectorAll(".js-file-field");

  fileFields.forEach((field) => {
    let fileInput = field.querySelector(".js-file-input");
    let fakeInput = field.querySelector(".js-fake-file-input");
    
    fileInput.addEventListener('change', function () {

      if (fileInput.files.length > 0) {
        // File selected, hide fake input and show real input
        fakeInput.style.display = 'none';
        fileInput.classList.add('field__input');
        fileInput.style.display = 'block';
      } else {
        // No file selected, hide real input and show fake input
        fakeInput.style.display = 'block';
        fileInput.classList.remove('field__input');
        fileInput.style.display = 'none';
      }
    })
  })
})